// ✅ Media Swiper Initializer
function initMediaSwipers(scope = document) {
  scope.querySelectorAll(".card-wrapper").forEach((el) => {
    const media_swiper = el.querySelector(".media-swiper");
    if (!media_swiper) return;
    if (media_swiper.classList.contains("swiper-initialized")) return; // prevent double init

    new Swiper(media_swiper, {
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: { crossFade: true },
      loop: true,
      autoplay: {
        delay: 60000000,
        disableOnInteraction: false,
      },
      pagination: {
        el: el.querySelector(".media-swiper-pagination"),
        clickable: true,
      },
      observer: true,
      observeParents: true,
      initialSlide: 0,
    });
  });
}

// ✅ Swatch Initializer
function initializeSwatches(scope = document) {
  const swatchBlocks = scope.querySelectorAll(".card-wrapper .color-swatches");

  swatchBlocks.forEach((block) => {
    block
      .querySelectorAll(".card-wrapper .quick-add__submit.button")
      .forEach((btn) => {
        if (!btn.hasAttribute("aria-haspopup")) {
          btn.setAttribute("aria-haspopup", "dialog");
        }
      });

    const firstLabel = block.querySelector(".swatch-label");
    if (!firstLabel) return;

    const swatch = firstLabel.querySelector(".swatch");
    const selectedColor = swatch ? swatch.getAttribute("title") : null;
    const productWishlistButton = block
      .closest(".card-wrapper")
      ?.querySelector(".wishlist_button");

    if (productWishlistButton && selectedColor) {
      productWishlistButton.setAttribute(
        "data-selected-variant-value",
        selectedColor
      );
    }

    firstLabel.classList.add("active");
    const swatchRadio = firstLabel.querySelector(".swatch-radio");
    if (swatchRadio) {
      swatchRadio.checked = true;
      firstLabel.click();
    }
  });
}

// ✅ Wait until swatches load
function waitForSwatchesToLoad(retries = 10, scope = document) {
  requestIdleCallback(() => {
    const swatches = scope.querySelectorAll(
      ".card-wrapper .color-swatches .swatch-label"
    );

    if (swatches.length) {
      initializeSwatches(scope);
    } else if (retries > 0) {
      setTimeout(() => waitForSwatchesToLoad(retries - 1, scope), 100);
    }
  });
}

// ✅ Safe init
function initAll(scope = document) {
  waitForSwatchesToLoad(10, scope);
  initMediaSwipers(scope);
}

// ✅ Global expose so pagination loader can call it
window.initAll = initAll;

if (document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", () => initAll());
} else {
  initAll();
}

// ✅ Re-init after Shopify section render
document.addEventListener("shopify:section:load", (e) => {
  initAll(e.target);
});

// ✅ Swatch click logic (delegation + swiper refresh)
document.addEventListener("click", (e) => {
  const label = e.target.closest(
    ".card-wrapper .color-swatches .swatch-label"
  );
  if (!label) return;

  const radio = label.querySelector(".swatch-radio");
  const swatch = label.querySelector(".swatch");
  const selectedColor = swatch ? swatch.getAttribute("title") : null;
  const variantId = radio ? radio.value : null;
  const cardWrapper = label.closest(".card-wrapper");
  const addToCartForm = cardWrapper?.querySelector(".quick-add form");
  const inputCart = addToCartForm?.querySelector("input[name='id']");
  const wishlistButton = cardWrapper?.querySelector(".wishlist_button");
  const btnCart = cardWrapper?.querySelector(
    ".card-wrapper .quick-add__submit.button"
  );


  if (radio) {
    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
  }

  if (inputCart && variantId) {
    inputCart.value = variantId;
    inputCart.dispatchEvent(new Event("change", { bubbles: true }));
  }

  if (wishlistButton && variantId) {
    wishlistButton.setAttribute("data-product-variant-id", variantId);
    if (selectedColor)
      wishlistButton.setAttribute("data-selected-variant-value", selectedColor);
  }
  if (selectedColor) {
    cardWrapper.querySelector(".selected_value").textContent = selectedColor;
  }

  if (btnCart) {
    btnCart.disabled = !variantId;
  }

  cardWrapper.querySelectorAll(".product-variant-id").forEach(inp => {
    inp.value = variantId;
    inp.dispatchEvent(new Event("change", { bubbles: true }));
  });

  label.parentElement
    .querySelectorAll(".swatch-label")
    .forEach((sibling) => sibling.classList.remove("active"));
  label.classList.add("active");

  // ✅ Replace images + refresh swiper
  const productVariantsData = cardWrapper?.querySelector(
    "#product-variants-data"
  )?.textContent;

  if (productVariantsData) {
    requestIdleCallback(() => {
      const productVariants = JSON.parse(productVariantsData);
      const selectedVariant = productVariants.find((v) => v.id == variantId);

      if (selectedVariant?.variant_image?.length) {
        const primaryImage = selectedVariant.variant_image[0];
        const secondaryImage =
          selectedVariant.variant_image[2] || primaryImage;

        const images = cardWrapper.querySelectorAll(".media img");

        if (images.length >= 2) {
          images[0].setAttribute("src", primaryImage);
          images[0].setAttribute("srcset", primaryImage);

          images[1].setAttribute("src", secondaryImage);
          images[1].setAttribute("srcset", secondaryImage);
        }


        // const swiperContainer = cardWrapper.querySelector(".media-swiper");
        // const swiperWrapper = swiperContainer?.querySelector(".swiper-wrapper");
        // const paginationEl = cardWrapper.querySelector(
        //   ".media-swiper-pagination"
        // );

        // if (swiperWrapper) {
        //   // destroy old swiper
        //   if (swiperContainer.swiper) {
        //     swiperContainer.swiper.destroy(true, true);
        //   }

        //   // fade out old slides
        //   swiperWrapper.style.opacity = "0";
        //   swiperWrapper.style.transition = "opacity 0.5s ease";

        //   // clear & rebuild slides
        //   swiperWrapper.innerHTML = "";
        //   images.forEach((url) => {
        //     const slide = document.createElement("div");
        //     slide.classList.add("swiper-slide");
        //     if (url.media_type === "video") {
        //       // TODO: handle video case
        //     } else {
        //       const img = document.createElement("img");
        //       img.src = `${url}&width=533`;
        //       img.srcset = [165, 360, 533, 720, 940, 1066, 1710]
        //         .map((w) => `${url}&width=${w} ${w}w`)
        //         .join(", ");
        //       img.sizes = "(min-width: 768px) 533px, 100vw";
        //       img.loading = "lazy";
        //       img.className = "main-img motion-reduce lazyload";

        //       slide.appendChild(img);
        //       swiperWrapper.appendChild(slide);
        //     }
        //   });

        //   // small delay before fade-in + re-init
        //   setTimeout(() => {
        //     const swiperInstance = new Swiper(swiperContainer, {
        //       slidesPerView: 1,
        //       effect: "fade",
        //       fadeEffect: { crossFade: true },
        //       loop: true,
        //       autoplay: {
        //         delay: 60000000,
        //         disableOnInteraction: false,
        //       },
        //       pagination: {
        //         el: paginationEl,
        //         clickable: true,
        //       },
        //       observer: true,
        //       observeParents: true,
        //       initialSlide: 0,
        //     });

        //     // force autoplay start (bug fix)
        //     setTimeout(() => {
        //       if (swiperInstance.autoplay) swiperInstance.autoplay.start();
        //     }, 200);

        //     // fade-in
        //     requestAnimationFrame(() => {
        //       swiperWrapper.style.opacity = "1";
        //     });

        //     // cleanup transition styles
        //     const cleanup = () => {
        //       swiperWrapper.style.transition = "";
        //       swiperWrapper.removeEventListener("transitionend", cleanup);
        //     };
        //     swiperWrapper.addEventListener("transitionend", cleanup);
        //     setTimeout(cleanup, 600);
        //   }, 120);
        // }
      }
    });
  }
});

// ✅ Toggle Menu via Delegation
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".toggle-btn");
  if (!btn) return;

  const card = btn.closest(".card-wrapper");
  const menuContainer = card?.querySelector(".menu-container");
  const mediaAfter = card?.querySelector(".card__media");

  if (menuContainer && mediaAfter) {
    menuContainer.classList.toggle("active");
    mediaAfter.classList.toggle("active");
  }
});
